import ClaimPodcastOwnershipModal from 'pages/Play/ClaimPodcastOwnershipModal';
import ConfigureFeedModal from 'pages/Play/ConfigureFeedModal';

interface ModalProps {}

const Modals: React.FC<ModalProps> = () => (
  <>
    <ClaimPodcastOwnershipModal />
    <ConfigureFeedModal />
  </>
);

export default Modals;
